import {PF_SORT_ASCENDING, PF_SORT_DESCENDING, PF_SORT_FEATURED} from "../constants/product-finder";

export const getPFSortIndex = (type) => {
    switch (type) {
        case PF_SORT_FEATURED: return 0;
        case PF_SORT_ASCENDING: return 1;
        case PF_SORT_DESCENDING: return 2;
        default: return 0;
    }
}

export const getPreviousSearches = () => {
    return JSON.parse(sessionStorage.getItem("pfPreviousSearches")) || [];
}